import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dirty-element-present"
export default class extends Controller {

	static targets = ['saveButton']

	connect() {
		this.dirtyElements = new Set()
		if (!this.hasSaveButtonTarget) { console.error('Missing save button!'); return }
	}

	addDirtyElement(element) {
		this.dirtyElements.add(element)
		this.updateSaveButton()
	}

	deleteDirtyElement(element) {
		this.dirtyElements.delete(element)
		this.updateSaveButton()
	}

	updateSaveButton() {
		if (this.dirtyElements !== undefined && this.dirtyElements.size > 0) {
			this.saveButtonTarget.removeAttribute('disabled')
			this.saveButtonTarget.classList.remove('bg-600')
			this.saveButtonTarget.classList.add('fa-beat')
			this.saveButtonTarget.classList.add('fa-animation-iteration-3x')
		} else {
			this.saveButtonTarget.disabled = true
			this.saveButtonTarget.classList.add('bg-600')
			this.saveButtonTarget.classList.remove('fa-beat')
			this.saveButtonTarget.classList.remove('fa-animation-iteration-3x')
		}
	}

}
